export default "__VITE_ASSET__5eA7f1B0__"